import httpRequest from "./index";
import { BaseService } from "@/api/baseService";
import type { ValidateCaptcha } from "../../../../common/types/message";

class MessageService extends BaseService<any, any, any, any> {
    public async sendPhoneCode(mobile: string, serialNumber: string) {
        const { data } = await this.service.get(`${this.path}/send/login`, { params: { mobile, serialNumber } });
        return data;
    }

    public async sendMsg(mobile: string, noNeedTenantId?: boolean) {
        const { data } = await this.service.get(`${this.path}/send`, { params: { mobile, noNeedTenantId } });
        return data;
    }

    public async checkMsg(mobile: string, code: string) {
        const { data } = await this.service.get(`${this.path}/check`, { params: { mobile, code } });
        return data;
    }

    public async validateCaptcha(params: ValidateCaptcha): Promise<{ code: string; data: boolean }> {
        return await this.service.post(`/captcha/send`, params);
    }

    // 发送短信验证码-换绑手机号
    public async sendChangeMobile(mobile: string) {
        const { data } = await this.service.get(`${this.path}/send/change/mobile`, { params: { mobile } });
        return data;
    }

    // 输入换绑手机号短信验证码后
    public async checkChangeMobile(mobile: string, code: string) {
        const { data } = await this.service.get(`${this.path}/check/change/mobile`, { params: { mobile, code } });
        return data;
    }

    /* 用户找回密码时的发送验证码 **/
    public async sendCaptchaOnFindPassword(account: string) {
        const { data } = await this.service.get(`${this.path}/send/captcha`, { params: { account } });
        return data;
    }

    /* 用户找回密码时的验证码效验**/
    public async checkCaptchaOnFindPassword(account: string, code: string) {
        const { data } = await this.service.get(`${this.path}/check/captcha`, { params: { account, code } });
        return data;
    }

    /* 用户找回密码时发送验证码 **/
    public async sendCaptchaOnUpdatePassword(account: string) {
        const { data } = await this.service.get(`${this.path}/send/captcha/modification`, { params: { account } });
        return data;
    }

    /* 用户在安全设置中的验证码效验 **/
    public async checkCaptchaOnSafeSetting(account: string, code: string): Promise<{ code: string; data: boolean }> {
        const { data } = await this.service.get(`${this.path}/check/captcha/modification`, {
            params: { account, code }
        });
        return data;
    }
}

export const messageService = new MessageService("/msg", httpRequest);
